module.exports = __webpack_public_path__ + "static/10-6326d6b08c58b30a3ee8c027b2a70bf5.jpg";